import { TypeExplanation } from 'app/constants/types/exam.types'
import React from 'react'

type Props = {}

const initialState = {
  papers: [],
  videos: [],
}

const useExamExplanation = (props: Props) => {
  const [returnedPapers, setReturnedPapers] = React.useState<TypeExplanation["papers"]>(initialState.papers)
  const [explanationVideos, setExplanationVideos] = React.useState<TypeExplanation["videos"]>(initialState.videos)

  return {
    returnedPapers,
    setReturnedPapers,
    explanationVideos,
    setExplanationVideos,
  }
}

export default useExamExplanation